import * as Config from '../../../../config';
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addToStackAutomix } from "../../automix/redux/actions/index";

const useGetRecs = (path = null) => {
  const [items, setItems] = useState(null);
  const api = useSelector(state => state.api);
  const dispatch = useDispatch();

  useEffect(() => {
    if (api && path) {
      api.getFromApi(path, false)
        .then( (response) => {
          const tracks = response.data.map(Config.formattedFromRecommendation(true));
          setItems(tracks);
          dispatch(addToStackAutomix(tracks));
        })
        .catch( e => console.log(`error getFromApi`, e) );
    }
  }, [api, path, dispatch])

  return { items };
};

export default useGetRecs;
